import { render } from "./RateItem.vue?vue&type=template&id=363a099f&scoped=true"
import script from "./RateItem.vue?vue&type=script&lang=js"
export * from "./RateItem.vue?vue&type=script&lang=js"

import "./RateItem.vue?vue&type=style&index=0&id=363a099f&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363a099f"]])

export default __exports__